import { Box, BoxProps, Text, TextProps } from 'grommet';

export type DividerProps = {
  color?: string;
  height?: BoxProps['height'];
  fill?: BoxProps['fill'];
  elevation?: BoxProps['elevation'];
  text?: string;
  textGap?: BoxProps['gap'];
  textProps?: TextProps;
};

export const Divider = ({
  color = 'border-divider',
  height = '1px',
  fill = 'horizontal',
  elevation = 'xsmall',
  text,
  textGap = 'xsmall',
  textProps,
}: DividerProps) => {
  const Divider = () => <Box height={height} background={color} fill={fill} elevation={elevation} />;

  return text ? (
    <Box direction="row" align="center" gap={textGap}>
      <Divider />
      <Box flex="grow">
        <Text size="xsmall" color="dark-2" {...textProps}>
          {text}
        </Text>
      </Box>
      <Divider />
    </Box>
  ) : (
    <Divider />
  );
};
